import InputFieldwithSearch from "../inputfields/InputFieldwithSearch";
import ButtonWithImg from "../buttons/ButtonWithImg";
import Filter from "./Filter";
import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { showToast } from "../toastMessage/toastSlice";
import useApi from "../../services/useApi";
import useTranslation from "../CustomHooks/useTranslation";
import { breadcrumbsContent } from "../breadcrumbs/BreadcrumbsContent";

interface TableTopBarProps {
  onSearch: (value: string) => void;
  onFilter: (filters: { [key: string]: string | boolean | null }) => void;
  // searchValue: string | null;
  loading: boolean;
  searchPlaceholder: string | undefined;
  searchParams: URLSearchParams;
  filters: boolean;
  search?: boolean;
  serviceNow?: boolean;
  exporting: boolean;
  endpoint?: string;
  disableExport?: boolean;
  disableSearchAndFilter?: boolean;
  recordCount?: number;
  placeholderClassName?: string;
  mainEndPoint?: string;
  mnoList?: boolean;
  amountList?: boolean;
  showFilter?: boolean;
  activeList?: string;
  statusNotFilter?: boolean;
}

const TableTopBar = ({
  onSearch,
  onFilter,
  // searchValue,
  searchParams,
  searchPlaceholder,
  loading,
  filters,
  search,
  endpoint,
  disableExport,
  exporting,
  serviceNow,
  disableSearchAndFilter,
  recordCount,
  placeholderClassName,
  mainEndPoint,
  mnoList,
  amountList,
  showFilter,
  activeList,
  statusNotFilter
}: TableTopBarProps) => {
  const [isExportOpen, setIsExportOpen] = useState(false);
  const exportRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [searchValue, setSearchValue] = useState("");
  const { translate, notEnglish } = useTranslation(breadcrumbsContent)
  const { getAPI } = useApi();
  const [exportLoading, setExportLoading] = useState(false);
  const handleClickOutside = (event: MouseEvent) => {
    if (
      exportRef.current &&
      !exportRef.current.contains(event.target as Node)
    ) {
      setIsExportOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const exportOptions = [
    { label: "CSV", value: "csv", textColorClass: "text-positive" },
    { label: "PDF", value: "pdf", textColorClass: "text-s_dark_hover" },
    // { label: "XLSX", value: "xlsx", textColorClass: "text-positive" },
  ];
  const handleExportOptionClick = async (value: string): Promise<void> => {
    setIsExportOpen(false);
    try {
      setExportLoading(true);
      let res;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      res = await getAPI(`${endpoint}&export_format=${value}&client_timezone=${timezone}`);

      if (!res.error) {
        if (res.data.url) {
          window.open(res.data.url, "_blank");
          dispatch(
            showToast({
              type: "success",
              message: translate("List exported successfully"),
            })
          );
        }else{
          dispatch(
            showToast({
              type: "success",
              message: translate("Export in progress. You'll receive an email with the PDF once it's ready."),
            })
          );
        }
      } else {
        dispatch(
          showToast({
            type: "error",
            message: "something went wrong",
          })
        );
      }
    } catch (error) {
      dispatch(
        showToast({
          type: "error",
          message: "something went wrong",
        })
      );
    } finally {
      setExportLoading(false);
    }
  };

  useEffect(() => {
    const searchValue = searchParams.get("search");
    setSearchValue(searchValue || "");
  }, [searchParams]);

  return (
    <div className={`flex justify-between items-center py-4 px-6 ${(disableSearchAndFilter || !search) ? '' : 'border-b'}`} dir={notEnglish ? "rtl" : "ltr"}>
      <div className="w-[310px]">
        {((!disableSearchAndFilter || loading) && search) && <InputFieldwithSearch
          handleSearchValue={onSearch}
          testId="search_id_table"
          searchValue={searchValue}
          placeHolder={searchPlaceholder}
          disableSearchAndFilter={disableSearchAndFilter}
          placeholderClassName={placeholderClassName}
        />}
      </div>
      <div className="flex gap-x-3 items-center justify-center">
        {((filters && showFilter) || (filters && (recordCount && recordCount > 0))) ? (
          <Filter
            onFilter={onFilter}
            searchParams={searchParams}
            disabled={loading}
            serviceNow={serviceNow}
            loading={loading}
            mainEndPoint={mainEndPoint}
            mnoList={mnoList}
            amountList={amountList}
            statusNotFilter={statusNotFilter}
          />
        ): null}
        <div className="relative" ref={exportRef}>
          {((exporting && !disableSearchAndFilter)) && (
            <ButtonWithImg
              buttonName={translate("Export")}
              disabledButton={loading || disableExport}
              ImgSrc={(loading || disableExport) ? 'loading-export' : 'export'}
              testId="export"
              className={`px-4 bg-p_primary text-white ${notEnglish ? 'w-fit' : 'w-[110px]'} `}
              buttonOnclick={() => setIsExportOpen(!isExportOpen)}
              loading={exportLoading}
            />
          )}
          {isExportOpen && (
            <div className="absolute right-0 mt-1 w-[110px] bg-white border border-s_dark_hover rounded-lg z-[11]">
              <ul className="flex flex-col">
                {exportOptions.map((option) => (
                  <li
                    key={option.value}
                    data-testid={`${option.value}`}
                    className={`p-2 text-body2 cursor-pointer ${option.textColorClass} hover:bg-p_light rounded-lg`}
                    onClick={() => handleExportOptionClick(option.value)}
                  >
                    {option.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableTopBar;
